import { useWeb3React } from '@web3-react/core';
import { formatUnits, parseUnits } from 'ethers/lib/utils';
import useSWR from 'swr';
import { config } from '../../../config/config';
import { ITradeManager__factory } from '../../../config/contracts/typechain';
import { verifyChainConfig } from '../../../helpers';
import useChartState from '../../../context/chart/useChartState';

const useFundingFeesRate = () => {
    const { library, chainId } = useWeb3React();

    const { selectedTradePair } = useChartState();

    const { data, error } = useSWR(
        library && chainId && selectedTradePair
            ? ['fundingFeesRate', library, chainId, selectedTradePair]
            : null,
        async (_, library, chainId, tradePair) => {
            if (!verifyChainConfig(chainId)) return;

            const tradeManagerContract = ITradeManager__factory.connect(
                config.addresses[chainId].tradeManager,
                library
            );

            const fees = await tradeManagerContract.getCurrentFundingFeeRates(
                tradePair.address
            );

            // When no positions are open, the returned fees will be zero. Frontend should display a negative value in thise case.
            let longFee = fees[0];
            let shortFee = fees[1];

            if (longFee.eq(0)) {
                longFee = parseUnits('-0.001', 14);
            }
            if (shortFee.eq(0)) {
                shortFee = parseUnits('-0.001', 14);
            }

            return {
                long: formatUnits(longFee.mul(100), 14),
                short: formatUnits(shortFee.mul(100), 14),
            };
        },
        { refreshInterval: 2000, dedupingInterval: 2000 }
    );

    return { fundingFeesRate: data, isLoading: !error && !data, error };
};

export default useFundingFeesRate;
